import axios from 'axios'


export default axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {

        'Content-type': 'application/json'
    }
})

export const AxiosProvider2 = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL2,
    headers: {

        'Content-type': 'application/json'
    }
}) 
